module.exports = __webpack_public_path__ + "img/AMBS.0d3ce14d.png";